import numeral from 'numeral';

export default (columnKey, cellValue) => {
  let value;
  const classList = [];

  switch (columnKey) {
    case 'timeSeries': {
      value = cellValue;
      break;
    }
    default: {
      if (!cellValue) {
        value = null;
        break;
      }
      if (columnKey === 'year') {
        classList.push('year');
      }
      if (cellValue < 0) {
        classList.push('negative');
      }
      value = numeral(cellValue).format('0.00%');
      break;
    }
  }

  return { value, classList };
};
